module.exports = __webpack_public_path__ + "6cc33e370d074ad8ad5ae99c0f91f7c4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/camo.png
// module id = 2739
// module chunks = 0